export default __webpack_public_path__ + "static/media/webbanner.95665e55.jpg";